import type { CommunityScheduledQueuePost } from './_components/scheduledQueue/ScheduledQueueRow';
import type { CommunitySchedulePickerTranslate } from './_components/schedulePicker/SchedulePickerFrame';

export const communityScheduledPostDestinationLabel = (
  channel: CommunityScheduledQueuePost['channel'],
  translate: CommunitySchedulePickerTranslate,
) => {
  if (!channel) return translate('community.composer.destination_feed');
  if (channel.deleted) return translate('community.composer.schedule.queue.deleted_channel', { channel: channel.name });
  return `#${channel.name}`;
};
